import React, { useState, useRef, Fragment } from 'react';
import {translate} from "../../Services/translation";
import { useElementHeight } from '../Hooks/useElementHeight.js';

const CategoryHeader = (props) => {
    const [isVisible, setIsVisible] = useState(false);
    const mainElement = document.getElementById("categoryDescription");

    const textRef = useRef();
    let textHeight = useElementHeight(textRef);
    
    if (textHeight > 75) {
        mainElement.classList.add("hide-text");
    }

    const toggleText = () => {
        setIsVisible(!isVisible)
        const text = document.getElementById('categoryDescription'); 
        if (!isVisible) {
            text.classList.add('show');
        }
        else {
            text.classList.remove('show');
        }
    }

    return (
        <div className="small-category-header" id="categoryDescription">
            <div className="text-content" ref={textRef}>
                {props.description &&
                    <div className="small-12 descripton">
                        {props.description}
                    </div>
                }
                <ul className="usp-list">
                    {props.usps && props.usps.map((usp, index) => (
                        <li
                        key={index}
                        >
                            {usp.categoryText}
                        </li>
                    ))} 
                </ul>
                {props.linkText &&
                    <a href="#category-footer-id" className="category-header__cta">
                        {props.linkText}
                    </a>
                }
            </div>
            <a className="toggle-button__read-more" onClick={ () => toggleText()}>{translate('category.page.read.more')}</a>
            <a className="toggle-button__show-less" onClick={ () => toggleText()}>{translate('category.page.show.less')}</a>
        </div>
    )
}

export default CategoryHeader;